import { Component, Input, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

@Component({
    selector: 'app-time-entries-task-view',
    template: `
    <nx-default-box 
        class="bg-white border-b border-gray"
        [label]="'Zeiterfassung'">
        <div class="flex items-center">
          <ng-container
            *ngIf="buildTimeEntryString(); else noTimeEntries">
            <div *ngIf="buildTimeEntryString()" (click)="openTimeEntries($event)" class="cursor-pointer">
              {{buildTimeEntryString()}}
            </div>
            <p-overlayPanel
                [style]="{'width':'670px'}"
                #overlayPanel>
                <div class="flex flex-col nx-time-entries-overlay">
                    <div>
                        <div
                            *ngIf="task.timeEntries == undefined || task.timeEntries.length == 0" 
                            class="text-base text-[#848488] font-light text-center">
                            Keine Zeiteinträge vorhanden.
                        </div>
                        <table
                            *ngIf="task.timeEntries && task.timeEntries.length > 0"
                            class="time-entries-table">
                            <thead class="time-entries-table">
                                <tr>
                                    <th>Start</th>
                                    <th>Ende</th>
                                    <th>Pause</th>
                                    <th>Dauer</th>
                                    <th>Kategorie</th>
                                    <th>Nutzer</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let timeEntry of task.timeEntries">
                                    <td class="text">{{timeEntry.startDateTime | date:'dd.MM.yy HH:mm'}}</td>
                                    <td class="text">{{timeEntry.endDateTime | date:'dd.MM.yy HH:mm'}}</td>
                                    <td class="text">{{timeEntry.pauseDuration | secondsToDuration}}</td>
                                    <td class="text">{{timeEntry.duration | secondsToDuration}}</td>
                                    <td class="text">{{timeEntry.category?.name}}</td>
                                    <td class="text">{{timeEntry.user?.firstName + ' ' + timeEntry?.user?.lastName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </p-overlayPanel>
          </ng-container>
          <ng-template #noTimeEntries>
            -
          </ng-template>
        </div>
    </nx-default-box>
    `,
    styles: [`
    .time-entries-table{
        font-size: 14px;
    }
    .time-entries-table tbody {
        display: block;
        max-height: 200px; /* fixe Höhe */
        overflow-y: auto; /* scrollbar */
    }
    .time-entries-table thead, .time-entries-table tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        text-align: left;
        font-weight: 400;
    }
  `]
})
export class TimeEntriesTaskViewComponent{

    @Input() task: Task;
    @ViewChild('overlayPanel') overlayPanel: OverlayPanel;

    constructor() {
    }

    buildTimeEntryString() {
      if(this.task == undefined || this.task.timeEntries == undefined || this.task.timeEntries.length == 0){
          return undefined;
      }
      // count time entries
      let count = this.task.timeEntries.length;
      // calcualte xxh yymin from time entries sum (seconds)
      let seconds = this.task.timeEntriesSum;
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      return `${count} Einträge, ${hours}:${minutes} h`;
  }

  openTimeEntries($event: any) {
    console.log(this.task.timeEntries);
    this.overlayPanel.toggle($event);
    event.stopPropagation();
  }
}